import {
  GET_ACCOUNT_THIRD_PARTY_ORDER_DETAILS,
  GET_ACCOUNT_THIRD_PARTY_ORDER_LIST,
  GET_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS,
  IU_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS,
} from "../../utils/constants";

const initialState = [];

function accountThirdPartyOrderReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ACCOUNT_THIRD_PARTY_ORDER_LIST:
      return [...state, payload];
    case GET_ACCOUNT_THIRD_PARTY_ORDER_DETAILS:
      return [...state, payload];
    case GET_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS:
      return [...state, payload];
    case IU_ACCOUNT_THIRD_PARTY_VENDOR_ORDER_DETAILS:
      return [...state, payload];
    default:
      return state;
  }
}

export default accountThirdPartyOrderReducer;
